export const passwordPattern = /^[A-Za-z0-9]+$/;
